/* Towlivesmatter 2026 homepage: prev/next controls for scroll-snap sliders. */
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('.tlm-slider__track');
    const count = root.querySelector('[data-count]');
    const btns = root.querySelectorAll('.tlm-slider__btn');
    if (!track) return;
    const items = () => [...track.children];
    const step = () => (items()[1] ? items()[1].offsetLeft - items()[0].offsetLeft : track.clientWidth);
    const update = () => {
      const all = items();
      const perView = Math.max(1, Math.round(track.clientWidth / step()));
      const first = Math.round(track.scrollLeft / step());
      const last = Math.min(all.length, first + perView);
      if (count) count.textContent = perView >= all.length ? '' : `${first + 1}${last > first + 1 ? '–' + last : ''} / ${all.length}`;
      btns.forEach((b) => {
        const dir = +b.dataset.dir;
        b.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      root.classList.toggle('is-static', perView >= all.length);
    };
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btns.forEach((b) => b.addEventListener('click', () => {
      track.scrollBy({ left: step() * +b.dataset.dir, behavior: reduce ? 'auto' : 'smooth' });
    }));
    let t;
    track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  const run = () => document.querySelectorAll('[data-tlm-slider]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
